import React from "react";
import { connect } from "react-redux";

import { Creators } from "./reducer";

export const withFirebase = (WrappedComponent, paths = [], listeners = []) => {
  class BaseFirebaseWrapper extends React.Component {
    componentDidMount() {
      paths.map(path => this.props.loadPath(path));

      listeners.map(path => this.props.listenToPath(path));
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return connect(
    state => ({}), // No state (yet)
    dispatch => ({
      loadPath: path => dispatch(Creators.loadPath(path)),
      listenToPath: path => dispatch(Creators.listenToPath(path))
    })
  )(BaseFirebaseWrapper);
};



// WEBPACK FOOTER //
// ./src/data/index.js